import _ from "lodash";
import React, { useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import { api } from "../utils";

export default function ProspectTypeAhead(props) {
  const [inputValue, setInputValue] = useState("");

  const loadOptions = (typedValue, callback) => {
    if (!typedValue || !typedValue.length || typedValue.length < 2) {
      return;
    }
    api
      .fetch("Customer/ProspectsTypeAhead", { searchString: typedValue })
      .then((response) => {
        const list = _.map(response.data, (d) => ({ label: d.name, value: d.stringId }));
        callback(list);
      })
      .catch(() => {
        toast.error("There was an error loading prospect information.");
        callback([]);
      });
  };

  function selectProspect(newProspect) {
      props.onChange(newProspect);
  }

  return (
    <AsyncSelect
      classNamePrefix='serviceThreadSelect'
      loadOptions={loadOptions}
      onInputChange={(e) => setInputValue(e)}
      onChange={selectProspect}
      inputValue={inputValue}
      value={props.value}
      isDisabled={props.disabled}
      onFocus={props.onFocus}
      isClearable
      placeholder={props.placeholder || "Type the prospect you are looking for"} 
    />);
} 